import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../css/modal.css";
import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import API from "../../../utils/API";

const Create = ({ SessionDetail, fetchSessionsDetail }) => {
  // Modal open state
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [campuses, setCampuses] = useState([]);
  const [sessions, setSessions] = useState([]);

  const defaltData = {
    campus_id: "",
    session_id: "",
    is_active: 0,
    is_next: 0,
    is_previous: 0,
    is_feedback_enabled: 0,
    is_enrollment_open: 0,
  };
  const [data, setData] = useState(defaltData);

  useEffect(() => {
    fetchCampuses();
  }, []);

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchCampuses = async () => {
    try {
      setLoading(true);
      const response = (await API.get("/api/campuses")).data;
      setCampuses(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = (await API.get("/api/sessions")).data;
      setSessions(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // Toggle for Modal
  const toggle = () => setModal(!modal);
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await API.post("/api/session-details", data);
      setLoading(false);
      fetchSessionsDetail();
      toggle();
      setData(defaltData);
      setErrors([]);
    } catch (error) {
      setErrors(
        error?.response?.data?.errors ? error.response.data.errors : []
      );
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    if (errors.length) setErrors([]);
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleChangeCheckbox = (e) => {
    if (errors.length) setErrors([]);
    setData({ ...data, [e.target.name]: e.target.checked ? 1 : 0 });
  };

  return (
    <div>
      <Button color="primary" className="rounded-pill" onClick={toggle}>
        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
        Create New
      </Button>

      <Modal
        centered
        scrollable
        size="lg"
        toggle={toggle}
        isOpen={modal}
        fade={true}>
        <ModalHeader toggle={toggle}>Add Session</ModalHeader>
        <Form method="POST" action="#" onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label for="campus_id">Campus</Label>
              <Input
                className="rounded-2"
                id="campus_id"
                required
                type="select"
                name="campus_id"
                onChange={handleChange}>
                <option value="">Select Campus</option>
                {campuses.map((campus) => (
                  <option key={campus.id} value={campus.id}>
                    {campus.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="session_id">Session</Label>
              <Input
                className="rounded-2"
                id="session_id"
                required
                type="select"
                name="session_id"
                onChange={handleChange}>
                <option value="">Select Session</option>
                {sessions.map((session) => (
                  <option key={session.id} value={session.id}>
                    {session.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <div className="row mt-4">
              <div className="col-md-4">
                <FormGroup>
                  <Label for="is_active" className="label-required">
                    Active
                  </Label>
                  <Input
                    className="rounded-2"
                    id="is_active"
                    type="checkbox"
                    name="is_active"
                    maxLength={255}
                    value={data.is_active}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
              <div className="col-md-4">
                <FormGroup>
                  <Label for="is_next" className="label-required">
                    Next
                  </Label>
                  <Input
                    className="rounded-2"
                    id="is_next"
                    type="checkbox"
                    name="is_next"
                    maxLength={255}
                    value={data.is_next}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
              <div className="col-md-4">
                <FormGroup>
                  <Label for="is_previous" className="label-required">
                    Previous
                  </Label>
                  <Input
                    className="rounded-2"
                    id="is_previous"
                    type="checkbox"
                    name="is_previous"
                    maxLength={255}
                    value={data.is_previous}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <FormGroup>
                  <Label for="is_feedback_enabled" className="label-required">
                    Feedback Enabled
                  </Label>
                  <Input
                    className="rounded-2"
                    id="is_feedback_enabled"
                    type="checkbox"
                    name="is_feedback_enabled"
                    maxLength={255}
                    value={data.is_feedback_enabled}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
              <div className="col-md-4">
                <FormGroup>
                  <Label for="is_enrollment_open" className="label-required">
                    Enrollment Open
                  </Label>
                  <Input
                    className="rounded-2"
                    id="is_enrollment_open"
                    type="checkbox"
                    name="is_enrollment_open"
                    maxLength={255}
                    value={data.is_enrollment_open}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={toggle}
              color="light"
              className="rounded-2">
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              className="rounded-2"
              disabled={loading}>
              {loading && (
                <Spinner className="me-2" size="sm">
                  Loading...
                </Spinner>
              )}
              Submit
            </Button>{" "}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default Create;
